/**
 * ÐÐ°ÑÐ¸ÑÐ° Ð¾Ñ Ð¿Ð¾Ð²ÑÐ¾ÑÐ½ÑÑ Ð¿ÐµÑÐµÑÐ¾Ð´Ð¾Ð² Ð½Ð° Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ðµ Ð­Ð¦Ð.
 *
 * ÐÐ»Ð¸ÐµÐ½Ñ Ð½Ð°Ð¶Ð¸Ð¼Ð°ÐµÑ Â«ÐÐµÑÐµÐ¹ÑÐ¸ Ðº Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸ÑÂ», ÑÑÐ¾Ð´Ð¸Ñ Ð½Ð° ÑÑÑÐ°Ð½Ð¸ÑÑ Aitu, Ð½Ðµ Ð´Ð¾Ð¶Ð¸Ð´Ð°ÐµÑÑÑ
 * ÐºÐ¾Ð´Ð° Ð¸ Ð²Ð¾Ð·Ð²ÑÐ°ÑÐ°ÐµÑÑÑ ÐºÐ½Ð¾Ð¿ÐºÐ¾Ð¹ Â«Ð½Ð°Ð·Ð°Ð´Â». Ð¡ÑÑÐ°Ð½Ð¸ÑÐ° Ð·Ð°Ð³ÑÑÐ¶Ð°ÐµÑÑÑ Ð·Ð°Ð½Ð¾Ð²Ð¾, ÐºÐ½Ð¾Ð¿ÐºÐ° ÑÐ½Ð¾Ð²Ð°
 * Ð°ÐºÑÐ¸Ð²Ð½Ð° â Ð¾Ð½ Ð¶Ð¼ÑÑ ÐµÑÑ ÑÐ°Ð·, Ð¸ ÐºÐ°Ð¶Ð´Ð¾Ðµ Ð½Ð°Ð¶Ð°ÑÐ¸Ðµ Ð´Ð»Ñ Aitu ÑÑÐ¾ Ð½Ð¾Ð²ÑÐ¹ Ð·Ð°Ð¿ÑÐ¾Ñ ÐºÐ¾Ð´Ð°.
 * 19.10.2026 Ð¿Ð¾ Ð¾Ð´Ð½Ð¾Ð¹ ÑÑÑÐ»ÐºÐµ Ð½Ð°Ð±ÐµÐ³Ð°Ð»Ð¾ 3-4 Ð¿ÐµÑÐµÑÐ¾Ð´Ð° Ð·Ð° 17 ÑÐµÐºÑÐ½Ð´, Ð¿Ð¾ÑÐ»Ðµ ÑÐµÐ³Ð¾
 * ÑÐµÑÐ²Ð¸Ñ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ñ Ð¾ÑÐ²ÐµÑÐ°Ð» Â«ÑÐ»Ð¸ÑÐºÐ¾Ð¼ Ð¼Ð½Ð¾Ð³Ð¾ Ð·Ð°Ð¿ÑÐ¾ÑÐ¾Ð² ÐºÐ¾Ð´Ð°Â» Ð¸ ÐºÐ»Ð¸ÐµÐ½Ñ Ð½Ðµ Ð¼Ð¾Ð³
 * Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°ÑÑ Ð²Ð¾Ð²ÑÐµ.
 *
 * ÐÐ¾ÑÑÐ¾Ð¼Ñ Ð¼Ð¾Ð¼ÐµÐ½Ñ Ð¿ÐµÑÐµÑÐ¾Ð´Ð° Ð·Ð°Ð¿Ð¾Ð¼Ð¸Ð½Ð°ÐµÐ¼ Ð² Ð±ÑÐ°ÑÐ·ÐµÑÐµ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð¸ Ð¼Ð¸Ð½ÑÑÑ Ð´ÐµÑÐ¶Ð¸Ð¼ ÐºÐ½Ð¾Ð¿ÐºÑ
 * Ð·Ð°ÐºÑÑÑÐ¾Ð¹, Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°Ñ Ð¾ÑÑÑÑÑ.
 */

/** Ð¡ÐºÐ¾Ð»ÑÐºÐ¾ Ð¶Ð´Ð°ÑÑ Ð´Ð¾ ÑÐ»ÐµÐ´ÑÑÑÐµÐ³Ð¾ Ð¿ÐµÑÐµÑÐ¾Ð´Ð°. ÐÐ¾Ð´ Ð¾Ñ Aitu Ð¾Ð±ÑÑÐ½Ð¾ Ð¿ÑÐ¸ÑÐ¾Ð´Ð¸Ñ Ð·Ð° Ð¼Ð¸Ð½ÑÑÑ. */
export const ECP_RESEND_SECONDS = 60;

const KEY_PREFIX = 'ecp-sign-started:';

export const storageKey = (signUrl) => `${KEY_PREFIX}${signUrl ?? ''}`;

/**
 * Ð¡ÐºÐ¾Ð»ÑÐºÐ¾ ÑÐµÐºÑÐ½Ð´ Ð¾ÑÑÐ°Ð»Ð¾ÑÑ Ð¶Ð´Ð°ÑÑ. 0 â Ð¿ÐµÑÐµÑÐ¾Ð´Ð¸ÑÑ Ð¼Ð¾Ð¶Ð½Ð¾.
 * ÐÑÐµÐ¼Ñ Ð² Ð±ÑÐ´ÑÑÐµÐ¼ (ÑÐ°ÑÑ Ð½Ð° ÑÐµÐ»ÐµÑÐ¾Ð½Ðµ Ð¿ÐµÑÐµÐ²ÐµÐ»Ð¸) Ð½Ðµ Ð´ÐµÑÐ¶Ð¸Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ°: Ð»ÑÑÑÐµ Ð¿ÑÐ¾Ð¿ÑÑÑÐ¸ÑÑ
 * Ð»Ð¸ÑÐ½Ð¸Ð¹ Ð¿ÐµÑÐµÑÐ¾Ð´, ÑÐµÐ¼ Ð·Ð°Ð¿ÐµÑÐµÑÑ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ðµ Ð´Ð¾ ÐºÐ¾Ð½ÑÐ° ÑÑÑÐ¾Ðº.
 */
export const secondsLeft = (startedAt, now = Date.now(), timeout = ECP_RESEND_SECONDS) => {
  const started = Number(startedAt);
  if (!startedAt || Number.isNaN(started)) return 0;
  const passed = Math.floor((now - started) / 1000);
  if (passed < 0) return 0;
  const left = timeout - passed;
  return left > 0 ? left : 0;
};

/** ÐÑÑÑÑÑ Ð´Ð»Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ°: 0:47. */
export const formatLeft = (seconds) => {
  const safe = seconds > 0 ? seconds : 0;
  const min = Math.floor(safe / 60);
  const sec = safe % 60;
  return `${min}:${String(sec).padStart(2, '0')}`;
};

/** Ð¥ÑÐ°Ð½Ð¸Ð»Ð¸ÑÐµ Ð¼Ð¾Ð¶ÐµÑ Ð±ÑÑÑ Ð½ÐµÐ´Ð¾ÑÑÑÐ¿Ð½Ð¾ (Ð¿ÑÐ¸Ð²Ð°ÑÐ½ÑÐ¹ ÑÐµÐ¶Ð¸Ð¼) â ÑÐ¾Ð³Ð´Ð° Ð¿ÑÐ¾ÑÑÐ¾ Ð½Ðµ Ð´ÐµÑÐ¶Ð¸Ð¼. */
export const readStartedAt = (signUrl, storage) => {
  try {
    return (storage || window.localStorage).getItem(storageKey(signUrl));
  } catch (e) {
    return null;
  }
};

export const rememberStart = (signUrl, now = Date.now(), storage) => {
  try {
    (storage || window.localStorage).setItem(storageKey(signUrl), String(now));
  } catch (e) {
    // Ð¿ÑÐ¸Ð²Ð°ÑÐ½ÑÐ¹ ÑÐµÐ¶Ð¸Ð¼ Ð¸Ð»Ð¸ Ð¿ÐµÑÐµÐ¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ðµ â Ð¿ÐµÑÐµÑÐ¾Ð´ Ð²ÑÑ ÑÐ°Ð²Ð½Ð¾ ÑÐ°Ð·ÑÐµÑÐ°ÐµÐ¼
  }
};
